import React, { useEffect, useState } from 'react'
import { useAuthServices } from '../../services/useFetch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faEnvelope, faPhone, faBuilding, faIdCard, faBriefcase, faGear, faCalendarDays, faUsers, faHandHoldingMedical, faClock, faSortNumericDown, faSortNumericUp, faSearch, faBroom } from '@fortawesome/free-solid-svg-icons';
import { Paginador } from '../Paginacion/Paginador';
import './companys.css';

export const ListaCompanys = ({ setSelectAction, setSelectedCompany }) => {

    const { requestPost } = useAuthServices();

    const tiposDeNegocio = [
        { value: '', label: 'Seleccione tipo de negocio' },
        { value: 'NEGOCIO_1', label: 'Salud, bienestar y cuidado personal' },
        { value: 'NEGOCIO_2', label: 'Belleza, peluquería y cuidado estético' },
        { value: 'NEGOCIO_3', label: 'Clínicas y servicios veterinarios' }
    ]

    const tiposDeGestion = [
        { value: '', label: 'Seleccione tipo de gestión' },
        { value: 'GESTION_1', label: 'Gestión propia' },
        { value: 'GESTION_2', label: 'Gestión institucional' }
    ]

    const [allCompanys, setAllCompanys] = useState([]);
    const [companys, setCompanys] = useState([])
    const [orden, setOrden] = useState('DESC');
    const [filtros, setFiltros] = useState({
        identificacion: '',
        correo: '',
        tipoNegocio: '',
        tipoGestion: ''
    });
    const [executeConsulta, setExecuteConsulta] = useState(false);
    const [paginacion, setPaginacion] = useState({
        totalElementos: '0',
        elementosPorPagina: '6',
        paginaActual: '1'
    });

    useEffect(() => {
        consultaCompanysService()
    }, [orden])

    const consultaCompanysService = async () => {
        const body = {
            "orden": orden
        }
        const response = await requestPost(body, 18);
        if (!response.error) {
            const { estado, objeto } = response.data
            if (estado) {
                setAllCompanys(objeto);
                filtrarDatos(objeto, filtros);
            }
        }
    }

    const filtrarDatos = (datos, filtrosAplicados) => {
        let resultado = datos || [];

        if (filtrosAplicados.tipoNegocio) {
            resultado = resultado.filter(c => c.tipoNegocio === filtrosAplicados.tipoNegocio);
        }
        if (filtrosAplicados.tipoGestion) {
            resultado = resultado.filter(c => c.tipoGestion === filtrosAplicados.tipoGestion);
        }
        if (filtrosAplicados.identificacion) {
            resultado = resultado.filter(c => c.identificacion.includes(filtrosAplicados.identificacion));
        }
        if (filtrosAplicados.correo) {
            resultado = resultado.filter(c => c.correo.toLowerCase().includes(filtrosAplicados.correo.toLowerCase()));
        }

        setCompanys(resultado);
        setPaginacion(prev => ({
            ...prev,
            totalElementos: resultado.length.toString(),
            paginaActual: '1'
        }));
    }

    const handleFiltroChange = (e) => {
        setFiltros({
            ...filtros,
            [e.target.name]: e.target.value
        });
    };

    const buscarConFiltros = () => {
        filtrarDatos(allCompanys, filtros);
    }

    const limpiarFiltros = () => {
        const emptyFiltros = { identificacion: '', correo: '', tipoNegocio: '', tipoGestion: '' };
        setFiltros(emptyFiltros);
        filtrarDatos(allCompanys, emptyFiltros);
    };

    const getPaginatedCompanys = () => {
        const indexPage = (parseInt(paginacion.paginaActual, 10) - 1) * parseInt(paginacion.elementosPorPagina, 10);
        const limitPage = indexPage + parseInt(paginacion.elementosPorPagina, 10);
        return (companys || []).slice(indexPage, limitPage);
    };

    return (
        <div className="div-mis-companys-container">
            <div className="card-filtros-company mb-4">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-6 mb-2">
                        <small className="label-filtro">Tipo de Negocio</small>
                        <select className="form-select form-select-sm" name="tipoNegocio" value={filtros.tipoNegocio} onChange={handleFiltroChange}>
                            {tiposDeNegocio.map((item, idx) => (
                                <option key={idx} value={item.value}>{item.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 mb-2">
                        <small className="label-filtro">Tipo de Gestión</small>
                        <select className="form-select form-select-sm" name="tipoGestion" value={filtros.tipoGestion} onChange={handleFiltroChange}>
                            {tiposDeGestion.map((item, idx) => (
                                <option key={idx} value={item.value}>{item.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 mb-2">
                        <small className="label-filtro">Identificación</small>
                        <input type="text" className="form-control form-control-sm" name="identificacion" value={filtros.identificacion} onChange={handleFiltroChange} placeholder="Buscar por ID..." />
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 mb-2">
                        <small className="label-filtro">Correo</small>
                        <input type="text" className="form-control form-control-sm" name="correo" value={filtros.correo} onChange={handleFiltroChange} placeholder="Buscar por correo..." />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-12">
                        <div className="div-bottom-custom gap-2 mt-3 mb-0 justify-content-center">
                            <button className="bottom-custom-secondary" onClick={limpiarFiltros}>
                                <FontAwesomeIcon icon={faBroom} className="me-2" />
                                Limpiar
                            </button>
                            <button className="bottom-custom" onClick={buscarConFiltros}>
                                <FontAwesomeIcon icon={faSearch} className="me-2" />
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="mb-0">Compañías registradas en el sistema:</h4>
                <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => setOrden(orden === 'ASC' ? 'DESC' : 'ASC')}
                    title={`Ordenar por fecha: ${orden === 'ASC' ? 'Más Recientes' : 'Más Antiguos'}`}
                >
                    <FontAwesomeIcon icon={orden === 'ASC' ? faSortNumericDown : faSortNumericUp} className="me-2" />
                    {orden === 'ASC' ? 'Más Antiguos' : 'Más Recientes'}
                </button>
            </div>
            <div className="row m-0 p-0">
                {
                    getPaginatedCompanys().length > 0 ?
                        getPaginatedCompanys().map((company) => (
                            <div key={company.id} className="col-12 col-md-12 col-lg-6 mb-3 p-0">
                                <div className="card-company">
                                    <div className="card-company-header">
                                        <h5 className="company-name">{company.nombres} {company.apellidos}</h5>
                                        <div className="company-institution">
                                            <FontAwesomeIcon icon={faBuilding} />
                                            <span className="mx-1">{company.nombreInstitucion} (ID: {company.idInstitucion})</span>
                                        </div>
                                        <div className="company-registration-info mt-0">
                                            <small className="text-white">
                                                <FontAwesomeIcon icon={faClock} className="me-1" />
                                                Registrado el {company.fechaRegistro} a las {company.horaRegistro}
                                            </small>
                                        </div>
                                    </div>
                                    <div className="card-company-body">
                                        <div className="info-item-company">
                                            <div className="icon-company-detail">
                                                <FontAwesomeIcon icon={faIdCard} />
                                            </div>
                                            <div>
                                                <span className="label-info-company-small">Identificación</span>
                                                {company.identificacion}
                                            </div>
                                        </div>
                                        <div className="info-item-company">
                                            <div className="icon-company-detail">
                                                <FontAwesomeIcon icon={faEnvelope} />
                                            </div>
                                            <div>
                                                <span className="label-info-company-small">Correo</span>
                                                {company.correo}
                                            </div>
                                        </div>
                                        <div className="info-item-company">
                                            <div className="icon-company-detail">
                                                <FontAwesomeIcon icon={faPhone} />
                                            </div>
                                            <div>
                                                <span className="label-info-company-small">Teléfono</span>
                                                {company.telefono}
                                            </div>
                                        </div>
                                        <hr className="my-2" />
                                        <div className="d-flex justify-content-between mt-2">
                                            <div className="info-item-company mb-0">
                                                <div className="icon-company-detail">
                                                    <FontAwesomeIcon icon={faBriefcase} />
                                                </div>
                                                <div>
                                                    <span className="label-info-company-small">Negocio</span>
                                                    <span className="badge-negocio">{company.labelTipoDeNegocio}</span>
                                                </div>
                                            </div>
                                            <div className="info-item-company mb-0">
                                                <div className="icon-company-detail">
                                                    <FontAwesomeIcon icon={faGear} />
                                                </div>
                                                <div>
                                                    <span className="label-info-company-small">Gestión</span>
                                                    <span className="badge-gestion">{company.labelTipoDeGestion}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-company-footer">
                                        <button className="btn-icon-action" title="Agendamiento" onClick={() => { setSelectedCompany(company); setSelectAction('VER_AGENDA'); }}>
                                            <FontAwesomeIcon icon={faCalendarDays} />
                                        </button>
                                        <button className="btn-icon-action" title="Clientes" onClick={() => { setSelectedCompany(company); setSelectAction('VER_CLIENTES'); }}>
                                            <FontAwesomeIcon icon={faUsers} />
                                        </button>
                                        <button className="btn-icon-action" title="Servicios" onClick={() => { setSelectedCompany(company); setSelectAction('VER_SERVICIOS'); }}>
                                            <FontAwesomeIcon icon={faHandHoldingMedical} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                        :
                        <div className="col-12 text-center py-5">
                            <div className="div-container-no-data-agenda py-5">
                                <FontAwesomeIcon icon={faExclamationTriangle} size="3x" className="text-muted mb-3" />
                                <p className="p-label-form">No se encontraron compañías registradas en el sistema.</p>
                            </div>
                        </div>
                }
            </div>
            <Paginador
                elementsPaginacion={paginacion}
                setElementsPaginacion={setPaginacion}
                setExecuteConsulta={setExecuteConsulta}
                executeConsulta={executeConsulta}
            />
        </div >
    )
}
